import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, withCtx as _withCtx, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e6d114e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ss-login" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-lg-8 ant-col-xl-8" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "ss-login-logo",
  src: "/static/img/ss-logo.png",
  alt: "NeoX - Sabre Sistemas"
}, null, -1))
const _hoisted_5 = { class: "ss-login-dados-autenticacao" }
const _hoisted_6 = { class: "ant-row" }
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "ss-login-label" }, "E-mail", -1))
const _hoisted_9 = { class: "ant-input-wrapper ant-input-group" }
const _hoisted_10 = { class: "ant-input-group-addon" }
const _hoisted_11 = { class: "ant-row" }
const _hoisted_12 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "ss-login-label" }, "Senha", -1))
const _hoisted_14 = {
  key: 1,
  class: "ant-row"
}
const _hoisted_15 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "ss-login-label" }, "Chave do Parceiro", -1))
const _hoisted_17 = { class: "ant-input-wrapper ant-input-group" }
const _hoisted_18 = { class: "ant-input-group-addon" }
const _hoisted_19 = { class: "ant-row" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-12" }, null, -1))
const _hoisted_21 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-12",
  style: {"text-align":"right"}
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-login-consultor" }, [
  /*#__PURE__*/_createTextVNode("Necessita de ajuda?"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://atendimento.sabresistemas.com.br/"
  }, "Fale com nosso suporte técnico.")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_icone = _resolveComponent("icone")!
  const _component_campo_senha = _resolveComponent("campo-senha")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_quadro_login = _resolveComponent("quadro-login")!
  const _component_a_list_item_meta = _resolveComponent("a-list-item-meta")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          (_ctx.state.mensagemAlerta)
            ? (_openBlock(), _createBlock(_component_a_alert, {
                key: 0,
                message: _ctx.state.mensagemAlerta,
                banner: ""
              }, null, 8, ["message"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("span", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, [
                  _createVNode(_component_icone, {
                    class: "ss-icone",
                    nome: "usuario-preenchido"
                  })
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "ant-input",
                  style: {"text-align":"left"},
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.dadosLogin.login) = $event)),
                  onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.efetuarLogin && _ctx.efetuarLogin(...args)), ["enter"])),
                  onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.buscarEmpresasEmail && _ctx.buscarEmpresasEmail(...args)))
                }, null, 544), [
                  [_vModelText, _ctx.state.dadosLogin.login]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(_component_a_spin, {
                size: "small",
                spinning: _ctx.state.carregandoEmpresas
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_campo_senha, {
                    valor: _ctx.state.dadosLogin.senha,
                    "onUpdate:valor": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.dadosLogin.senha) = $event)),
                    onKeyEnter: _ctx.efetuarLogin
                  }, null, 8, ["valor", "onKeyEnter"])
                ]),
                _: 1
              }, 8, ["spinning"])
            ])
          ]),
          (_ctx.state.exibirCampoParceiro)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("span", _hoisted_17, [
                    _createElementVNode("span", _hoisted_18, [
                      _createVNode(_component_icone, {
                        class: "ss-icone",
                        nome: "usuario-preenchido"
                      })
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "ant-input",
                      style: {"text-align":"left"},
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.dadosLogin.chaveParceiro) = $event)),
                      onKeyup: _cache[5] || (_cache[5] = _withKeys(
//@ts-ignore
(...args) => (_ctx.efetuarLogin && _ctx.efetuarLogin(...args)), ["enter"]))
                    }, null, 544), [
                      [_vModelText, _ctx.state.dadosLogin.chaveParceiro]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("a", {
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.redefinirSenha && _ctx.redefinirSenha(...args)))
              }, "Esqueci minha senha")
            ])
          ]),
          _createElementVNode("button", {
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.efetuarLogin && _ctx.efetuarLogin(...args))),
            class: "ss-login-btn"
          }, "Acessar"),
          _hoisted_22
        ])
      ]),
      _createVNode(_component_quadro_login)
    ]),
    _createVNode(_component_a_modal, {
      open: _ctx.state.exibirSelecaoEmpresa,
      "onUpdate:open": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.exibirSelecaoEmpresa) = $event)),
      title: "Selecione a Empresa",
      footer: null,
      width: "600px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_list, {
          "data-source": _ctx.state.empresasVinculadas,
          style: {"cursor":"pointer"}
        }, {
          renderItem: _withCtx(({ item }) => [
            _createVNode(_component_a_list_item, {
              onClick: ($event: any) => (_ctx.selecionarEmpresa(item))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_list_item_meta, null, {
                  title: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.codigoExibicao) + " - " + _toDisplayString(item.nomeExibicao), 1)
                  ]),
                  description: _withCtx(() => [
                    _createTextVNode(" CNPJ: " + _toDisplayString(_ctx.formatarCNPJ(item.cpfCnpj)), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }, 8, ["data-source"])
      ]),
      _: 1
    }, 8, ["open"])
  ]))
}